import React from 'react';

import Button from '@adsk/alloy-react-button';
import { MoreHorizontalIcon, MoreVerticalIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import type { ButtonTemplateProps } from '../../types';

type ActionButtonProps = ButtonTemplateProps & {
  horizontal?: boolean;
};

const ActionButtonControl = ({
  targetProps,
  show,
  handleToggle,
  className,
  style,
  disabled,
  horizontal,
  onClick,
  ...props
}: ActionButtonProps) => (
  <Button
    className={className}
    disabled={disabled}
    renderIcon={(p) =>
      horizontal ? <MoreHorizontalIcon {...p} /> : <MoreVerticalIcon {...p} />
    }
    onClick={(...args) => {
      onClick?.(...args);
      handleToggle();
    }}
    style={[
      {
        backgroundColor: show
          ? theme.tokens.colors.background.neutral.selected.value
          : theme.tokens.colors.background.primary.value,
      },
      disabled && {
        '&:active': {
          borderColor: theme.tokens.colors.border.inactive.value,
        },
      },
      style,
    ]}
    {...props}
    {...targetProps}
  />
);

export default ActionButtonControl;
